export const loginPage = {
    // start
    lpStarted: 'Registration-start-started',
    lpStartSignIn: 'Registration-start-signIn',
    lpStartIos: 'Registration-app-download',
    // creat
    lpSignIn: 'Registration-accountCreate-signIn',
    lpCreatNext: 'Registration-accountCreate-next',
    // Activate
    lpActiveBack: 'Registration-accountActivate-back',
    lpActiveSend: 'Registration-accountActivate-sendAgain',
    lpActiveActive: 'Registration-accountActivate-activate',
    // Complete
    lpCompleteBack: 'Registration-accountComplete-back',
    lpCompleteDone: 'Registration-accountComplete-done',
    // failed
    lpFailedOK: 'Registration-accountFailed-ok',
    lpFailedBack:'Registration-accountFailed-back',
    // error
    lpErrorOK: 'Registration-accountError-ok',
    //regist
    lpRegistBack:'Registration-accountRegist-back',
    lpRegistSignIn:'Registration-accountRegist-signIn',
    // share操作
    lpShare:'Registration-share-btn',
    lpShareSave:'Registration-share-save',
    lpShareClose:'Registration-share-cancel',
}